export const API_URL =
  process.env.NODE_ENV === 'production'
    ? `${process.env.REACT_APP_API_URL}/api`
    : `${process.env.REACT_APP_API_URL}/api`;
